import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const CsvIcon = ({ color = '#16a099', text = 'CSV' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default CsvIcon;
